import React from 'react';
import { useTranslation } from "react-i18next";
import { WeekData } from '../../../services/backend/api/shifts/responses/monthly-calendar-response';

interface MonthBarProps {
    currentMonth: number;
    currentYear: number;
    monthData: WeekData[];
    onToggleAll: (show: boolean) => void;
    formatShiftCount: (count: number) => string;
    getMonthShiftsCount: (weeks: WeekData[]) => number;
}

const MonthBar: React.FC<MonthBarProps> = ({
    currentMonth,
    currentYear,
    monthData,
    onToggleAll,
    formatShiftCount,
    getMonthShiftsCount
}) => {
    const { t } = useTranslation();

    return (
        <div className="flex items-center justify-between cursor-pointer select-none px-2 py-1 rounded-lg">
            <div className="flex items-center gap-3">
                <span className="font-bold text-lg tracking-wide">
                    {t(`shiftAssignmentPage.months.${new Date(currentYear, currentMonth).toLocaleString('en-US', { month: 'long' }).toLowerCase()}`)}
                </span>
                <span className="text-sm text-white px-2 py-1 rounded">
                    {formatShiftCount(getMonthShiftsCount(monthData))}
                </span>
            </div>
            <div className="flex gap-2">
                <button 
                    className="text-sm text-gray-300 focus:outline-none hover:text-white"
                    onClick={() => onToggleAll(true)}
                >
                    {t('shiftAssignmentPage.showAll')}
                </button>
                <span className="text-gray-300">|</span>
                <button 
                    className="text-sm text-gray-300 focus:outline-none hover:text-white"
                    onClick={() => onToggleAll(false)}
                >
                    {t('shiftAssignmentPage.hideAll')}
                </button>
            </div>
        </div>
    );
};

export default MonthBar; 